import React, { useMemo } from 'react';
import { CurrencyAttributes } from '@loyalty/shared-common/gamification-api-client';
import { CurrencyCounterAttributes } from '@loyalty/editor-components';
import { FormGroup } from '@mui/material';
import { getLocalizedProperty } from '@loyalty/shared-common';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SelectField } from '../../../../shared/forms/fields/SelectField';
import { SwitchField } from '../../../../shared/forms/fields/SwitchField';
import { Trait } from '../utils/Trait';
import { TraitFormValue } from '../types';
import { useCurrencies } from '../../../../currency/CurrenciesContext';

type FormValue = TraitFormValue<CurrencyCounterAttributes, void>;

export function CurrencyCounterWidgetTraits() {
  const { t, i18n } = useTranslation();
  const { currencies } = useCurrencies();

  const { control } = useFormContext<FormValue>();

  const currencyOptions = useMemo(
    () =>
      currencies
        .filter(value => !value.deletedAt)
        .map((currency: CurrencyAttributes) => ({
          id: currency.id,
          name: getLocalizedProperty(currency, 'name', i18n.language) || 'No name',
        })),
    [currencies, i18n.language, t],
  );

  return (
    <FormGroup>
      <Trait>
        <SelectField
          control={control}
          name="attributes.currencyId"
          label={t('editor.leaderboard.traits.currency')}
          options={currencyOptions}
        />
      </Trait>
      <Trait>
        <SwitchField<FormValue>
          name="attributes.showCurrencyPicture"
          label={t('editor.leaderboard.traits.showCurrencyPicture')}
        />
      </Trait>
      <Trait>
        <SwitchField<FormValue>
          name="attributes.showCurrencyName"
          label={t('editor.leaderboard.traits.showCurrencyName')}
        />
      </Trait>
      <Trait>
        <SwitchField<FormValue>
          name="attributes.showTotal"
          label={t('editor.leaderboard.traits.showTotal')}
        />
      </Trait>
      <Trait>
        <SwitchField<FormValue>
          name="attributes.showExpiration"
          label={t('editor.leaderboard.traits.showExpiration')}
        />
      </Trait>
    </FormGroup>
  );
}
